// View Training Requests


import { Component } from '@angular/core';
import { ConfirmEventType, ConfirmationService, Message, MessageService } from 'primeng/api';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-view-training-requests',
  templateUrl: './view-training-requests.component.html',
  styleUrls: ['./view-training-requests.component.scss'],
  providers: [MessageService]
})
export class ViewTrainingRequestsComponent {
  skeleton = true;
  translator:TranslatorPipe = new TranslatorPipe()

  //reject reason variable
  rejectReason : boolean = false
  reasonError : any
  rejectData = {
    _id: null,
    reason: null,
    status : ''
  };

  header = 'طلبات الدورة التدريبية';
  links: link[] = [
    {
      name: 'إنشاء طلب',
      icon: 'pi pi-fw pi-plus-circle',
      link: '/training/request',
      visible: this.hasPermission('TRAINING_REQUEST','c'),
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: 'Training Request', link: '/amin/data' },
  ];

  stats: stat[] = [];
  messages: Message[] = [];
  data: any[] = [];
  trainingRequestData: any[] = [];
  trainingTypes: any[] = [];
  createTrainingModal = false
  createCourseModal = false
  selectionModal =  false
  requestHolder : any

  status: string = 'PENDING';

  statusOptions: any[] = [
    { name: this.translate('pending'), value: 'PENDING' },
    { name: this.translate('Draft'), value: 'TRAINING_CREATED' },
    { name: this.translate('Accepted'), value: 'APPROVED' },
    { name: this.translate('Rejected'), value: 'REJECTED' },
    { name: this.translate('Sent for review'), value: 'REVISION' }
  ];

  constructor(
    private dataService: DataService,
    private permissionService:PermissionHandlerService,
    private confirmationService: ConfirmationService,
   
  ) { }

  ngOnInit() {
    

    this.getTrainingRequests();
    this.getTrainingTypes().then(() => {
      // this.makequestion();
    });
  }
  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
  hasPermission(unit:string,flag:string) {
    return this.permissionService.hasPermission(unit,flag);
  }

  //get all training requests
  getTrainingRequests = async () => {
    try {

      // this.skelition = true
      this.trainingRequestData = []
      this.data = []

      console.log("status =", this.status);

      let res = await this.dataService.postData('training-req/get/', { status : this.status});
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.trainingRequestData = res.data;
      this.trainingRequestData.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          topic: { n: item.topic, i: item.icon },
          type: { n: item?.type?.arabic },
          status : item.status,
          description: { n: item?.description },
          // الحالة: {
          //   n: item.active,
          //   i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          // },
          Action: [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.updateTypeCounts();
      this.skeleton = false;
      console.log('data ou catagory => ', this.trainingRequestData, this.data);
    } catch (error) {
      console.log(error);
    }
  };

  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      active: true,
    });
    console.log(res.data);
    if (res.error) {
      return;
    }
    this.trainingTypes = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      };
    });
  }

  async deactivateInit(){
    try {
      if (this.rejectData.reason == undefined && this.rejectData.status != 'APPROVED' && this.rejectData.status != 'TRAINING_CREATED') {
        this.reasonError = 'السبب مطلوب';
        return;
      }
      this.reasonError = undefined;
      let res = await this.dataService.postData('training-req/',this.rejectData,'PUT',false);
      if(!res.error){
        this.rejectReason = false
        this.rejectData = {
          _id: null,
          reason: null,
          status : ''
        };
      
        window.location.reload()
        
      } else {
        this.reasonError = res.msg;
      }

    } catch (error) {
      console.log(error)
    }  

  }


  
  markedRevised(id :any) {
    // confirm modal lagan h
    this.rejectData._id = id
    this.rejectData.status = 'TRAINING_CREATED'
      this.confirm({
        message: 'هل أنت متأكد أنك تريد الموافقة على هذا التعليق؟',
        header: 'رسالة التأكيد',
        icon: 'pi pi-exclamation-triangle',
        action: () => this.deactivateInit(),
      });

  }
  
  approve(id :any) {
    // confirm modal lagan h
    this.rejectData._id = id
    this.rejectData.status = 'APPROVED'
      this.confirm({
        message: 'هل أنت متأكد أنك تريد الموافقة على هذا التعليق؟',
        header: 'رسالة التأكيد',
        icon: 'pi pi-exclamation-triangle',
        action: () => this.deactivateInit(),
      });

  }

  confirm(parems: any) {

    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }


  openCourseModal = false
  trainingDetails = undefined



  async openCourse(req:any){
    try {

      this.openCourseModal = true
      let res = await this.dataService.getData('course/'+req._id);
      if(res.error){
        return
      }  
      this.trainingDetails = res.data[0]
      console.log("==>COurse get",res);
    } catch (error) {
      console.log(error);
    }

    
  }

  staticURL = GlobalConstants.staticFilesURL;
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false
    }
  }


  //updates the counts
  private updateTypeCounts(): void {
    let activeCount = this.trainingRequestData.filter(
      (e) => e.active === true
    ).length;
    let inactiveCount = this.trainingRequestData.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }
}
